import React, { useContext, useState } from "react";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "./ui/dialog";
import { AuthContext } from "../helpers/Auth";
import useAuthActions from "../hooks/useAuthActions";


const UserDeletePage = () => {
  const auth = useContext(AuthContext);
  const { deleteUser } = useAuthActions();
  const providerId = auth?.currentUser?.providerData?.[0]?.providerId;
  const email = auth?.currentUser?.providerData?.[0]?.uid;
  const [modalDeleteAlert, showModalDeleteAlert] = useState(false);
  const [entered_password, setEnteredPassword] = useState("");

  return (
    <>
      <div className="max-w-2xl mx-auto px-4">
        <h1 className="text-3xl font-bold my-4">User Deletion</h1>
        Deleting your user will remove all your projects, photos, firings, kilns, inventory, and any
        other information we hold on you.
        <p />
        If you signed in with Apple or Google, it won't delete your apple or Google ID, merely the
        information that kilnhelper holds about you.
        <p />
        This action cannot be undone, so please only use it if you really mean it. I genuinely won't
        be able to get your data back if you do.
        <p />
        {providerId === "password" ? (
          <>
            In order to guard against abuse, you will be required to enter your password again
            before deleting your users.
            <p />
            <Dialog open={modalDeleteAlert} onOpenChange={showModalDeleteAlert}>
              <DialogTrigger asChild>
                <Button variant="outline">Delete User</Button>
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Delete User?</DialogTitle>
                </DialogHeader>
                <div>
                  This can't be undone. Please enter your password to continue.
                  <p />
                  &nbsp;
                  <p />
                  Password:{" "}
                  <input
                    name="password"
                    type="password"
                    onChange={(e) => setEnteredPassword(e.target.value)}
                  />
                </div>
                <DialogFooter>
                  <Button variant="secondary" onClick={() => showModalDeleteAlert(false)}>
                    Cancel
                  </Button>
                  <Button
                    variant="destructive"
                    onClick={() => {
                      showModalDeleteAlert(false);
                      deleteUser(providerId ?? "", email ?? "", entered_password);
                    }}
                  >
                    Delete User data
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
          </>
        ) : (
          <Dialog open={modalDeleteAlert} onOpenChange={showModalDeleteAlert}>
            <DialogTrigger asChild>
              <Button variant="outline">Delete User</Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader>
                <DialogTitle>Delete User?</DialogTitle>
              </DialogHeader>
              <div>
                This can't be undone.
                <p />
                &nbsp;
                <p />
                Please note - you may be required to re-authenticate yourself before your deletion
                request can be processed.
              </div>
              <DialogFooter>
                <Button variant="secondary" onClick={() => showModalDeleteAlert(false)}>
                  Cancel
                </Button>
                <Button
                  variant="destructive"
                  onClick={() => {
                    deleteUser(providerId ?? "", email ?? "");
                  }}
                >
                  Delete User data
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        )}
      </div>
    </>
  );
};

export default UserDeletePage;
